import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Device } from '../types';
import { Paper, Typography, Box } from '@mui/material';

interface DeviceMapProps {
  devices: Device[];
  onDeviceSelect: (device: Device) => void;
}

// Componente para iniciar o mapa mostrando todo o Brasil
const BrazilView = () => {
  const map = useMap();
  
  useEffect(() => {
    // Coordenadas aproximadas que cobrem todo o Brasil
    const brazilBounds = L.latLngBounds(
      L.latLng(-33.742, -73.985), // Ponto sudoeste extremo
      L.latLng(5.271, -34.793)    // Ponto nordeste extremo
    );
    
    // Ajustar o mapa para mostrar todo o Brasil
    map.fitBounds(brazilBounds, {
      animate: false,
      padding: [20, 20]
    });
  }, [map]);
  
  return null;
};

const DeviceMap: React.FC<DeviceMapProps> = ({ devices, onDeviceSelect }) => {
  const defaultCenter: L.LatLngExpression = [-14.235, -51.925]; // Centro do Brasil
  
  return (
    <MapContainer
      center={defaultCenter}
      zoom={4} // Zoom que mostra grande parte do Brasil
      style={{ height: '100%', width: '100%' }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      
      {/* Componente para inicializar a visão do Brasil */}
      <BrazilView />
      
      {devices.map((device) => (
        <Marker
          key={device.id}
          position={[device.location.latitude, device.location.longitude] as L.LatLngExpression}
          icon={L.divIcon({
            className: 'custom-div-icon',
            html: `<div style="background-color: ${device.online ? '#4caf50' : '#f44336'}; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white;"></div>`,
            iconSize: [20, 20],
            iconAnchor: [10, 10],
          })}
          eventHandlers={{
            click: () => onDeviceSelect(device)
          }}
        >
          <Popup>
            <Box>
              <Typography variant="subtitle1">{device.name}</Typography>
              <Typography variant="body2">{device.id}</Typography>
              <Typography variant="body2" color={device.online ? 'success.main' : 'error.main'}>
                {device.online ? 'Online' : 'Offline'}
              </Typography>
            </Box>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default DeviceMap;